<template>
  <b-modal
    v-model="modalVisible"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    body-class="delete-modal"
  >
    <b-container fluid>
      <b-button
        @click="$emit('close-delete-modal')"
        class="d-flex position-absolute close-btn"
      >
        <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
      </b-button>
      <b-row class="pt-2 d-flex flex-column" :style="{ paddingLeft: '15px' }">
        <h2
          v-if="!modal.isDeleted"
          class="modal_header font-md"
          :style="{ marginBottom: 0 }"
        >
          Are you sure?
        </h2>
        <h2 v-if="modal.isDeleted" class="modal_header font-md">
          Successfully deleted
        </h2>
        <h4 v-if="!modal.isDeleted" class="font-md subtext">
          Do you want to delete the following company?
        </h4>
        <h4 v-else class="font-md subtext">
          Following company has been successfully deleted.
        </h4>
      </b-row>
      <b-row align-v="center">
        <b-col class="flex-row d-flex pb-4" cols="7">
          <div :style="{ paddingRight: '10px' }">
            <b-avatar
              v-if="avatarThumbnail"
              :src="avatarThumbnail"
              size="8rem"
              class="pa-avatar bg--primary"
            ></b-avatar>
            <b-avatar
              v-else
              :text="getInitialsFromName(modal.name)"
              size="8rem"
              class="pa-avatar bg--primary"
            ></b-avatar>
          </div>
          <div class="d-flex flex-column position-relative ml-4">
            <p class="font-family-medium primary--text">{{ modal.name }}</p>
            <p class="secondary--text reduce-whitespace">
              {{ modal.subscriptionType }}
            </p>
          </div>
        </b-col>
        <b-col :style="{textAlign: 'center'}" cols="5">
          <b-button
            v-if="!modal.isDeleted"
            @click="$emit('confirm-delete')"
            class="btn-danger px-4 py-3 btn-pill reduce-whitespace"
            :disabled="modal.isProcessing"
          >
            <b-spinner
              v-if="modal.isProcessing"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${modal.isProcessing ? "" : "Confirm Delete"}` }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="modal.deleteError" class="mt-3">
        <b-col>
          <p class="text-danger">{{ modal.deleteError }}</p>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { getInitialsFromName } from "@/utils/utils";

export default {
  name: "DeleteCompanyModal",
  props: {
    modal: {
      type: Object,
      required: true,
      avatarThumbnail: { type: String },
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.modal.isOpen;
      },
      set(value) {
        if (!value) {
          this.$emit("close-delete-modal");
        }
      }
    }
  },
  methods: {
    getInitialsFromName
  }
};
</script>

<style scoped lang="scss">
.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}

::v-deep .delete-modal {
  padding: 2rem;
  h4.subtext {
    padding-bottom: 2.5rem;
  }
}
</style>
